import { matchPath } from 'react-router';
import { LucideIcon } from 'lucide-react';
import {
  ChartNoAxesCombined,
  MonitorDot,
  PieChart,
  TrendingUpDown,
  Mail,
  Flag,
  Eye,
  BarChart3,
  TrendingUp,
  Cpu,
  Compass,
  Layers,
  Radio,
  Search,
  LineChart,
  Radar,
} from 'lucide-react';

export enum AppServices {
  MM = 'mm',
  DA = 'da',
  MO = 'mo',
  LT = 'lt',
  SOS = 'sos',
}

export type MMMRoute = {
  url: string;
  name: string;
  subroutes?: MMMRoute[];
  icon: LucideIcon;
  service?: AppServices;
  isDevOnly?: boolean;
  isBeta?: boolean;
};

const routes: Array<MMMRoute> = [
  {
    url: '/mmm',
    name: 'Marketing Mix Modelling',
    icon: ChartNoAxesCombined,
    service: AppServices.MM,
    subroutes: [
      {
        url: '/mmm/overview',
        name: 'Overview',
        icon: Eye,
      },
      {
        url: '/mmm/summary',
        name: 'Summary',
        icon: BarChart3,
      },
      {
        url: '/mmm/trends',
        name: 'Trends',
        icon: TrendingUp,
      },
      {
        url: '/mmm/modelling',
        name: 'Modelling',
        icon: Cpu,
      },
    ],
  },
  {
    url: '/digital',
    name: 'Digital Attribution',
    icon: MonitorDot,
    service: AppServices.DA,
    subroutes: [
      {
        url: '/digital/overview',
        name: 'Overview',
        icon: Eye,
      },
      {
        url: '/digital/explorer',
        name: 'Campaign Explorer',
        icon: Compass,
      },
      {
        url: '/digital/deep-dive',
        name: 'Campaign Groups',
        icon: Layers,
      },
      {
        url: '/digital/channels',
        name: 'Channels',
        icon: Radio,
      },
      {
        url: '/digital/search',
        name: 'Search',
        icon: Search,
      },
    ],
  },
  {
    url: '/longterm-effect',
    name: 'Long Term Effect',
    icon: TrendingUpDown,
    service: AppServices.LT,
  },
  {
    url: '/marketing-optimization',
    name: 'Marketing Optimization',
    icon: PieChart,
    service: AppServices.MO,
  },
  {
    url: '/forecasting',
    name: 'Forecasting',
    icon: LineChart,
    service: AppServices.MO,
    isBeta: true,
  },
  {
    url: '/brand-tracking',
    name: 'Brand Tracking',
    icon: Radar,
  },
  {
    url: '/goals-and-targets',
    name: 'Goals',
    icon: Flag,
  },
  {
    url: '/inbox',
    name: 'Inbox',
    icon: Mail,
  },
];

export function getAllRoutes(): MMMRoute[] {
  return Object.values(routes);
}

export function getActiveRoute(pathname: string): MMMRoute | null {
  for (const route of routes) {
    if (matchPath(`${route.url}/*`, pathname)) {
      return route;
    }
  }

  return null;
}
